import { render, staticRenderFns } from "./AddListItemNote.vue?vue&type=template&id=7b1f1940&"
import script from "./AddListItemNote.vue?vue&type=script&lang=js&"
export * from "./AddListItemNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports